<h2 mat-dialog-title>{{ 'General.NoServerConnection' | translate }}</h2>
<mat-dialog-actions align="end">
    <button mat-flat-button (click)="retryConnection()" color="primary" class="w-100" [disabled]="isChecking">
        <span>
            {{ 'General.RetryServerConnection' | translate }}
        </span>
        @if (isChecking) {
            <mat-icon>
                <mat-spinner [diameter]="24" />
            </mat-icon>
        }
    </button>
</mat-dialog-actions>
